import { get, post } from './api'

import type { GetSsoLinksReponse, GetSSOAuthResponse } from './types/sso'

export const getSSOLinks = async (email: string) =>
  get<GetSsoLinksReponse>(
    `${process.env.API_BASE_URL}/auth/sso/links?email=${email}&redirect=${window.location.href}`
  )

export const getSSOAuth = async (code: string) =>
  post<GetSSOAuthResponse>(`${process.env.API_BASE_URL}/auth/sso/auth`, {
    code,
  })
